module.exports = __webpack_public_path__ + "img/result-success.be876fb8.svg";